export const Features = ({ data=[] }) => (
<section className="section section--process-v7" aria-labelledby="process-title">
  <div className="process-giant" aria-hidden="true">HOW<br/>WE<br/>WORK</div>
  <div className="site-container process-layout-v7">
    <div className="process-copy-v7"><p className="eyebrow eyebrow-on-dark">HOW WE WORK</p><h2 id="process-title">좋은 결과는<br/>좋은 과정에서<br/><span>시작됩니다.</span></h2></div>
    <div className="process-list-v7">{data.map((item,index)=><article className="process-card-v7" key={item.title} data-motion><span>0{index+1}</span><em>{item.kicker}</em><h3>{item.title}</h3><p>{item.text}</p><b>↘</b></article>)}</div>
  </div>
</section>);
